import { Page, PageRequestParams } from '../../common/queryClient';
import { UseApiQueryOptions } from '../../common/queryClient/createApiQueryHook';
import { useSystemClassifierItems } from '../../configuration';
import { ProcessingEventDirectoryEntryType } from '../../processingEvent/schema/types';
import {
  ProcessingEventsFilter,
  ProcessingEventsFilterKey,
  processingEventsFilterKeys,
  useInputProcessingEventsQuery,
} from '../../processingEvent/query/useInputProcessingEventsQuery';

export const INPUT_DATA_EVENT_LEVEL_CODES = ['ERROR', 'INFO'];
export const INPUT_DATA_PROCESSING_TYPE_CODES = [
  'LOAD_SAMPLE',
  'IMPUTE_DATA',
  'LOAD_DATA',
];

const processingEventsFilterKeysToExclude = [
  'dataObjectGroupId',
  'outputProcessingDataObjectId',
  'outputDataObjectDescriptionId',
  'outputDataObjectDescription',
  'outputDataObjectGroupType',
  'outputDataObjectDescriptionParent',
  'outputCalculationErrors',
  'outputVersionMissingSourceData',
  'outputVersionValidationErrorLevelId',
  'outputVersionStatus',
  'outputVersion',
  'outputVersionId',
  'permissionToManage',
] as const;

type ProcessingEventsFilterKeyToExclude =
  (typeof processingEventsFilterKeysToExclude)[number];

export const inputProcessingEventsFilterKeys =
  processingEventsFilterKeys.filter(
    (
      key,
    ): key is Exclude<
      ProcessingEventsFilterKey,
      ProcessingEventsFilterKeyToExclude
    > =>
      !processingEventsFilterKeysToExclude.includes(
        key as ProcessingEventsFilterKeyToExclude,
      ),
  );

export type InputProcessingEventsFilter = Omit<
  ProcessingEventsFilter,
  ProcessingEventsFilterKeyToExclude
>;

export type InputProcessingEventsFilterKey =
  (typeof inputProcessingEventsFilterKeys)[number];

export const useInputDataProcessingEventsQuery = (
  params: Partial<InputProcessingEventsFilter> & PageRequestParams,
  options: Partial<
    UseApiQueryOptions<Page<ProcessingEventDirectoryEntryType>>
  > = {},
) => {
  const errorLevelId = useSystemClassifierItems(
    'PROCESSING_ERROR_LEVEL',
    INPUT_DATA_EVENT_LEVEL_CODES,
  ).map(({ id }) => id);

  return useInputProcessingEventsQuery(
    {
      ...params,
      errorLevelId: params.errorLevelId?.length
        ? params.errorLevelId
        : errorLevelId,
    },
    options,
  );
};
